import React, { useState } from 'react'
import { withRouter } from 'react-router'
import { makeStyles, Grid, AppBar, Toolbar, Drawer, Hidden, IconButton, List, ListItem, ListItemIcon, Collapse, ListItemText, Typography, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import ExpandLessOutlined from '@material-ui/icons/ExpandLessOutlined';
import ExpandMoreOutlined from '@material-ui/icons/ExpandMoreOutlined';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import sections from './sections'
import { strings } from '../../../../localization/strings'

const useStyles = makeStyles((theme) => ({
    drawerPaper: {
        width: '30%',
        [theme.breakpoints.down('sm')]: {
            top: theme.mixins.toolbar.minHeight,
            width: '100vw',
            borderWidth: '0',
        },
    },
    drawerHeader: {
        padding: '20px',
    },
    drawer: {
        borderRight: '1px solid #ededed',
    },
    listContainer: {
        marginBottom: '30px',
        paddingBottom: '20px',
        overflowY: 'hidden',
        '&:hover': {
            overflowY: 'scroll',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#f2f1f1',
        },
        '&::-webkit-scrollbar': {
            background: 'inherit',
            width: '5px'
        }
    },
    listIcon: {
        fontSize: '20px',
        color: theme.palette.secondary.main,
        minWidth: '35px',
    },
    listItem: {
        borderBottom: '1px solid #ededed',
        '&:first-of-type': {
            borderTop: '1px solid #ededed',
        }
    },
    navbar: {
        zIndex: '1600',
    },
    logo: {
        width: '180px',
        [theme.breakpoints.down('sm')]: {
            width: '120px',
            margin: '0 10px',
            objectFit: 'contain',
        },
    },
    content: {
        width: '70%',
        marginLeft: '30%',
        flexGrow: 1,
        padding: '40px 100px',
        [theme.breakpoints.down('lg')]: {
            padding: '0 40px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
            padding: '0 30px',
        },
    },
    intro: {
        minHeight: '100vh',
        height: '600px',
        paddingTop: '20px',
        borderBottom: '1px solid #ededed',
    },
    introPudo: {
        marginTop: '40px',
        fontSize: '40px',
        fontWeight: 'bold'
    },
    introTitle: {
        fontSize: '40px',
        marginTop: '40px',
    },
    introSubtitle: {
        fontSize: '30px',
        marginTop: '40px',
    },
    introText: {
        marginTop: '40px',
        width: '70%',
        [theme.breakpoints.down('sm')]: {
            width: '80%',
        },
    },
    section: {
        paddingTop: '20px',
        borderBottom: '1px solid #ededed',
        wordBreak: 'break-word',
    },
    sectionTitle: {
        fontSize: '25px',
        fontWeight: '600',
        marginBottom: '15px',
        marginTop: '15px'
    },
    sectionSubtitle: {
        fontSize: '20px',
        fontWeight: '600',
    },
    sectionText: {
        marginTop: '30px',
        whiteSpace: 'pre-wrap',
    },
    sectionExample: {
        fontSize: '14px',
        fontFamily: 'Courier New, monospace',
        whiteSpace: 'pre-wrap',
        marginTop: '30px',
        marginBottom: '30px',
    },
    table: {
        borderCollapse: 'collapse',
        width: '100%',
        marginBottom: '50px',
    },
    tableHead: {
        backgroundColor: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        color: '#fff',
        padding: '10px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    tableRow: {
        border: 'none',
    },
    tableCell: {
        padding: '10px',
        border: `1px solid ${theme.palette.primary.main}`,
        whiteSpace: 'pre-wrap',
    },
}))

const EcommerceDocumentation = () => {
    const styles = useStyles()

    const [open, setOpen] = useState([])
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const logoImg = "data:image/png;base64,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"

    const toggleDropdown = (index) => {
        if (open.includes(index)) {
            setOpen(open.filter((item) => item !== index))
        } else {
            setOpen([...open, index])
        }
    }

    const handleDrawerToggle = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const renderMenuItems = (sections, depth = 0) => {
        return sections.map((item, index) => (
            <div key={index}>
                <ListItem button component={'a'} href={`EcommerceDocumentation/#${item.id}`} onClick={() => setIsDrawerOpen(false)} className={styles.listItem} style={{ paddingLeft: `${30 + depth * 20}px` }}>
                    <ListItemIcon onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleDropdown(index)
                    }}>
                        <>{item.submenu && open.includes(index) ? <ExpandLessOutlined className={styles.listIcon} /> : item.submenu ? <ExpandMoreOutlined className={styles.listIcon} /> : item.icon}</>
                    </ListItemIcon>
                    <ListItemText primary={item.menuTitle} />
                </ListItem>
                {item.submenu && (
                    <Collapse in={open.includes(index)} timeout={'auto'} unmountOnExit>
                        {renderMenuItems(item.submenu, depth + 1)}
                    </Collapse>
                )}
            </div>
        ))
    }

    const drawerContent = (
        <>
            <Hidden smDown implementation="css">
                <div className={styles.drawerHeader}>
                    <img className={styles.logo} src={logoImg} alt="logo" />
                </div>
            </Hidden>
            <List className={styles.listContainer}>{renderMenuItems(sections)}</List>
        </>
    );

    const renderContent = (section, index) => {
        return <div key={index}>
            <div style={{ marginBottom: '20px', paddingTop: '30px' }} id={section.id}>
                {section.title ? <Typography className={styles.sectionTitle}>{section.title}</Typography>
                    : null}
                {section.content && section.content.subtitle ?
                    <Typography className={styles.sectionSubtitle}>{section.content.subtitle}</Typography>
                    : null}
                {section.content && section.content.text ?
                    <Typography className={styles.sectionText}>{section.content.text}</Typography>
                    : null}
            </div>
            {section.content && section.content.table ? section.content.table.map((table, index) => (
                <Table className={styles.table} key={index}>
                    <TableHead className={styles.tableHead}>
                        {table.header.map((headerRow, rowIndex) => (
                            <TableRow className={styles.tableRow} key={rowIndex}>
                                {headerRow.map((header, index) => (
                                    <TableCell key={index} className={styles.tableHead} colSpan={header.colspan} style={{ backgroundColor: header.backgroundColor, color: header.color }}>{header.text}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableHead>
                    <TableBody>
                        {table.data.map((rowData, index) => {
                            return <TableRow key={index} className={styles.tableRow}>
                                {rowData.text.map((cellData, cellIndex) => (
                                    <TableCell key={cellIndex} className={styles.tableCell} colSpan={rowData.colspan} style={{ backgroundColor: rowData.backgroundColor, color: rowData.color, textAlign: rowData.textAlign }}>{cellData}</TableCell>
                                ))}
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            ))
                : null}
            {section.content && section.content.example ?
                <>
                    <Typography className={styles.sectionSubtitle}>{strings.ecommerceDocumentation.example}</Typography>
                    <Typography className={styles.sectionExample}>{section.content.example}</Typography>
                </>
                : null}
            {section.submenu &&
                section.submenu.map((submenu) => (
                    renderContent(submenu, submenu.id + index)
                ))}
        </div>
    }
    return (
        <Grid container className={styles.documentationContainer}>
            <Hidden mdUp>
                <Grid item xs={12}>
                    <AppBar position="fixed" color='inherit' elevation={0} className={styles.navbar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerToggle}>
                                {isDrawerOpen ? <CloseIcon /> : <MenuIcon />}
                            </IconButton>
                            <img className={styles.logo} src={logoImg} alt="logo" edge="end" />
                        </Toolbar>
                    </AppBar>
                    <Toolbar />
                </Grid>
            </Hidden >
            <Hidden mdUp implementation="css">
                <Drawer
                    variant="temporary"
                    open={isDrawerOpen}
                    onClose={handleDrawerToggle}
                    classes={{ paper: styles.drawerPaper }}
                    ModalProps={{ keepMounted: true }}
                >
                    {drawerContent}
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
                <Drawer
                    className={styles.drawer}
                    variant="permanent"
                    classes={{ paper: styles.drawerPaper }}
                    ModalProps={{ disableScrollLock: true }}
                >
                    {drawerContent}
                </Drawer>
            </Hidden>
            <main className={styles.content}>
                <section className={styles.intro} id="intro">
                    <Typography className={styles.introPudo}>{strings.ecommerceDocumentation.introPudo}</Typography>
                    <Typography className={styles.introTitle}>{strings.ecommerceDocumentation.introTitle}</Typography>
                    <Typography className={styles.introSubtitle}>{strings.ecommerceDocumentation.introSubtitle}</Typography>
                    <Typography className={styles.introText}>{strings.ecommerceDocumentation.introText} </Typography>
                </section>

                {sections.filter((section) => section.showSection !== false).map((section, index) => (
                    <section className={styles.section} id={section.id} key={index}>
                        {renderContent(section, index)}
                    </section>
                ))}
            </main>
        </Grid >
    )
}

export default withRouter(EcommerceDocumentation)